module.exports = __webpack_public_path__ + "static/img/s120.c9d7daee.png";